import EventDispatcher from '../util/EventDispatcher';
import Event from '../util/Event';
import { isNull } from '../util/TypeUtil';

export default class LanguagePack extends EventDispatcher {
    constructor() {
        super();
        this.verbose = false;
        this._textReplacements = [];
        this.reset();
    };

    reset() {
        this._entries = {};
    };

    convertToObject() {
        throw "Function convertToObject not implemented";
    };

    setPropertiesFromObject(object) {
        this._entries = {};
        this.createProperObjectCopy(object, this._entries);
        this.dispatchEvent(Event.CHANGE);
    };

    getText(label, prefix, applyReplacements) {
        if (typeof applyReplacements === 'undefined') { applyReplacements = true; }

        var result = this.getContent(label, LanguagePack.TEXT_TYPE, prefix);
        if (!isNull(result)) {
            var text = result;
            if (applyReplacements) {
                for (var i = 0; i < this._textReplacements.length; i++) {
                    var textReplacement = this._textReplacements[i];
                    text = text.split(textReplacement.text).join(textReplacement.replacement);
                }
            }
            return text;
        } else {
            if (this.verbose) {
                return label;
            } else {
                return null;
            }
        }
    };

    setText(label, value, prefix) {
        this.setContent(label, LanguagePack.TEXT_TYPE, value, prefix);
    };

    removeText(label, prefix) {
        this.removeContent(label, LanguagePack.TEXT_TYPE, prefix);
    };

    hasText(label, prefix) {
        return this.hasContent(label, LanguagePack.TEXT_TYPE, prefix);
    };

    getContent(label, type, prefix) {
        if (!prefix)
            prefix = "";

        var path = this.getFullLabel(label, prefix);
        var node = this.getNode(path, false);
        var result = null;
        if (node == null) {
            if (this.verbose) {
                console.info("LANGUAGEPACK ERROR: label \"" + label + "\"does not exist!");
            }
        } else {
            result = node[type];
            if (result == null && this.verbose) {
                console.info("LANGUAGEPACK ERROR: label \"" + label + "\"does not have a " + type + " property!");
            }
        }
        return result;
    };

    setContent(label, type, value, prefix) {
        if (!prefix)
            prefix = "";

        var path = this.getFullLabel(label, prefix);
        var node = this.getNode(path, true);
        node[type] = value;
        this.dispatchEvent(Event.CHANGE);
    };

    removeContent(label, type, prefix) {
        if (!prefix)
            prefix = "";

        var path = this.getFullLabel(label, prefix);
        if (type != null && type != "") {
            path += ("." + type);
        }
        this.deleteNode(path);
        this.dispatchEvent(Event.CHANGE);
    };

    hasContent(label, type, prefix) {
        if (!prefix)
            prefix = "";

        return this.getContent(label, type, prefix) != null;
    };

    getFullLabel(label, prefix) {
        return LanguagePack.getFullLabel(label, prefix);
    };

    static getFullLabel(label, prefix) {
        if (prefix != null && prefix != "") {
            return prefix + "." + label;
        }
        return label;
    };

    renameContent(label, newLabel, type, newType, prefix, newPrefix) {
        if (!type)
            type = "";
        if (!newType)
            newType = "";
        if (!prefix)
            prefix = "";
        if (!newPrefix)
            newPrefix = "";

        throw new Error("Function renameContent not implemented");
    };

    merge(languagePack, overwrite) {
        if (overwrite == null)
            overwrite = false;

        if (languagePack instanceof LanguagePack) {
            var newEntries = languagePack._entries;
            this.mergeObjects(this._entries, newEntries, overwrite);
        } else {
            throw new Error("Cannot merge with this languagepack implementation");
        }
        this.dispatchEvent(Event.CHANGE);
    };

    addReplacement(textReplacement) {
        // TextReplacement is an object of structure {text: ..., replacement: ...} 	
        this._textReplacements.push(textReplacement);
    };

    removeReplacement(textReplacement) {
        var index = this._textReplacements.indexOf(textReplacement);
        if (index != -1) {
            this._textReplacements.splice(index, 1);
        }
    };

    createProperObjectCopy(sourceObject, targetObject) {
        for (var key in sourceObject) {
            var value = sourceObject[key];
            var path = key.split(".");
            var pathLength = path.length;
            var nextTargetEntry = targetObject;
            for (var index = 0; index < pathLength; index++) {
                var targetEntry = nextTargetEntry;
                nextTargetEntry = targetEntry[path[index]];
                if (nextTargetEntry == null || typeof nextTargetEntry != "object") {
                    nextTargetEntry = targetEntry[path[index]] = {};
                }
            }

            if (typeof value != "object" || Object.prototype.toString.call(value) === '[object Array]') {
                targetEntry[path[pathLength - 1]] = value;
            } else {
                this.createProperObjectCopy(sourceObject[key], nextTargetEntry);
            }
        }
    };

    mergeObjects(object1, object2, overwrite) {
        if (overwrite == null)
            overwrite = false;

        for (var key in object2) {
            var value1 = object1[key];
            var value2 = object2[key];
            if (value1 == null) {
                object1[key] = value2;
            }
            else if (typeof value1 != "object" || typeof value2 != "object") {
                if (overwrite) {
                    object1[key] = value2;
                }
            } else {
                this.mergeObjects(value1, value2, overwrite);
            }
        }
    };

    getNode(path, createIfNeeded) {
        if (createIfNeeded == null)
            createIfNeeded = false;

        var nodeNames = path.split(".");
        var numNodes = nodeNames.length;
        var node = null;
        if (numNodes > 0) {
            node = this._entries;
            for (var index = 0; index < numNodes; index++) {
                var childNodeName = nodeNames[index];
                var childNode = node[childNodeName];
                if (childNode == null) {
                    if (createIfNeeded) {
                        childNode = node[childNodeName] = {};
                    } else {
                        node = null;
                        break;
                    }
                }
                node = childNode;
            }
        }
        return node;
    };

    deleteNode(path) {
        var nodeNames = path.split(".");
        var numNodes = nodeNames.length;
        var node = this._entries;
        var lastBranchedNode = node;
        var pathValid = true;
        var childNodeNameToDelete = null;
        for (var index = 0; index < numNodes; index++) {
            var nodeName = nodeNames[index];
            if (node[nodeName] != null) {
                for (var childNodeName in node) {
                    if (childNodeName != nodeName) {
                        lastBranchedNode = node;
                        childNodeNameToDelete = nodeName;
                        break;
                    }
                }
                node = node[nodeName];
            }
            else {
                pathValid = false;
                break;
            }
        }
        if (pathValid) {
            console.info((lastBranchedNode == this._entries) + " deleting " + childNodeNameToDelete);
            delete lastBranchedNode[childNodeNameToDelete];
        }
    };

}

LanguagePack.TEXT_TYPE = "text";
